<template>
    <div class="page-container">
        <el-breadcrumb separator="/" v-if="isShowBreadcrumb">
            <el-breadcrumb-item>
                <span class="page-title">系统设置</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>SITECONF</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="tab-wrap" v-if="isShowBreadcrumb">
            <el-tabs v-model="confType" @tab-click="handleConfTypeChange">
                <el-tab-pane label="SITE" name="s"></el-tab-pane>
                <el-tab-pane label="REDIS" name="r"></el-tab-pane>
            </el-tabs>
        </div>
        <div :style="{ 'margin-top': isShowBreadcrumb ? '' : '20px' }">
            <div class="input-wrap">
                <el-input v-model="searchWords" placeholder="key" class="key_input"></el-input>
            </div>
            <div class="search-btn-wrap">
                <el-button @click="handleSearch()" type="primary">搜索</el-button>
                <el-button @click="createVisible = true" type="success">新建</el-button>
            </div>
        </div>
        <div class="create-dialog">
            <el-dialog
                :title="'新建' + (confType == 'r' ? 'REDIS' : 'SITE')"
                :visible.sync="createVisible"
                width="50%"
                @closed="handleClose"
            >
                <div>
                    <el-form label-width="50px">
                        <el-form-item label="key:">
                            <el-input placeholder="请输入内容" v-model="k"> </el-input>
                        </el-form-item>
                        <el-form-item label="value:">
                            <el-input
                                type="textarea"
                                placeholder="请输入内容"
                                :rows="6"
                                v-model="v"
                                resize="both"
                            >
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="createVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleCreate()">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <conf-list @refresh="refreshList" @query="handleSearch"></conf-list>
    </div>
</template>

<script>
import './store';
import ConfList from './components/list';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'SiteConf',
    props: {
        isShowBreadcrumb: {
            type: Boolean,
            default: true,
        },
        currentKey: {
            type: String,
            default: '',
        },
    },
    components: {
        ConfList,
    },
    data() {
        return {
            confType: 's',
            searchWords: '',
            createVisible: false,
            k: '',
            v: '',
        };
    },
    mounted() {
        if (!this.isShowBreadcrumb) {
            this.searchWords = this.currentKey;
            this.handleSearch();
        }
    },
    methods: {
        ...mapActions('siteConf', ['list', 'create', 'setConfType', 'clearConfList']),
        refreshList(data = {}) {
            this.handleSearch();
        },
        handleSearch() {
            this.list({
                searchWords: this.searchWords,
            });
        },
        handleCreate() {
            this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(() => {
                this.create({
                    k: this.k,
                    v: this.v,
                }).then(() => {
                    this.$message.success('操作成功！');
                    this.createVisible = false;
                    this.handleClose();
                    this.refreshList();
                });
            });
        },
        handleClose() {
            this.k = '';
            this.v = '';
        },
        handleConfTypeChange(tab) {
            this.setConfType(tab.name);
            this.searchWords = '';
            this.clearConfList();
        },
    },
};
</script>

<style lang="less" scoped>
.tab-wrap {
    margin: 20px 0px;
}
.input-wrap {
    width: 400px;
    display: inline-block;
    margin-right: 20px;
}
.search-btn-wrap {
    display: inline-block;
}
</style>
